export default __webpack_public_path__ + "static/media/Unirab-20-ban.2b9bb722.jpg";